import React, {Component} from "react";
import sheet_logo from '../../images/csv_logo.png';

export class SheetLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getImage() {
        return sheet_logo;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        return <img alt="Planilla CSV" style={this.props.styles} src={this.getImage()} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}/>
    }
}
